export default {
  install: (app, options) => {
    const isUserMemberOfTeam = (teams) => {
      return teams.find((team) => team.isTeamOfCurrentUser) !== undefined;
    };

    const getUserTeam = (teams) => {
      return teams.find((team) => team.isTeamOfCurrentUser);
    };

    const getLastProgressDate = (progresses) => {
      return progresses.at(-1)?.date;
    };

    const hasExceededDeactivationTime = (competitiveChallenge) => {
      if (competitiveChallenge.deactivationAt) {
        return new Date() > new Date(competitiveChallenge.deactivationAt);
      }

      return false;
    };

    const hasExceededEndAt = (competitiveChallenge) => {
      if (competitiveChallenge.endAt) {
        return new Date() > new Date(competitiveChallenge.endAt);
      }

      return false;
    };

    const getStartAt = (competitiveChallenge) => {
      const userTeam = getUserTeam(
        competitiveChallenge.competitiveChallengeTeams
      );

      if (
        userTeam &&
        new Date(userTeam.createdAt) > new Date(competitiveChallenge.startAt)
      ) {
        return userTeam.createdAt;
      }

      return competitiveChallenge.startAt;
    };

    const hasChallengeStarted = (competitiveChallenge) => {
      const today = new Date();
      today.setMinutes(0);
      today.setHours(0);
      today.setSeconds(0);
      today.setMilliseconds(0);

      return today >= new Date(competitiveChallenge.startAt);
    };

    const getTodaysProgressOfUser = (competitiveChallenge) => {
      const today = new Date();
      const day = today.getDate();
      const month = today.getMonth();
      const year = today.getFullYear();

      const todaysProgress = competitiveChallenge.progressesOfCurrentUser.find(
        (progress) => {
          const progressDate = new Date(progress.date);
          const progressDateDay = progressDate.getDate();
          const progressDateMonth = progressDate.getMonth();
          const progressDateYear = progressDate.getFullYear();

          return (
            progressDateDay === day &&
            progressDateMonth === month &&
            progressDateYear === year
          );
        }
      );

      return todaysProgress ? todaysProgress.value : 0;
    };

    const getFirstValidProgressDate = (competitiveChallenge) => {
      const userTeam = getUserTeam(
        competitiveChallenge.competitiveChallengeTeams
      );

      if (
        userTeam &&
        new Date(userTeam.joinedAt) > new Date(competitiveChallenge.startAt)
      ) {
        return userTeam.joinedAt;
      }

      return competitiveChallenge.startAt;
    };

    const findTeamById = (competitiveChallengeTeams, teamId) => {
      return competitiveChallengeTeams.find(
        (team) => team.id === parseInt(teamId)
      );
    };

    app.config.globalProperties.$competitiveChallengeManager = {
      isUserMemberOfTeam,
      getUserTeam,
      getLastProgressDate,
      hasExceededDeactivationTime,
      getStartAt,
      hasChallengeStarted,
      hasExceededEndAt,
      getFirstValidProgressDate,
      findTeamById,
      getTodaysProgressOfUser,
    };
  },
};
